import { Textarea, Field } from '@chakra-ui/react';

interface TextElementFieldsProps {
  textContent: string
  textContentSpanish: string
  onChange: (field: 'textContent' | 'textContentSpanish', value: string) => void
}

export function TextElementFields({
  textContent,
  textContentSpanish,
  onChange,
}: TextElementFieldsProps) {
  return (
    <>
      <Field.Root>
        <Field.Label fontSize="sm">Script Text</Field.Label>
        <Textarea
          size="sm"
          rows={3}
          value={textContent}
          onChange={(e) => onChange('textContent', e.target.value)}
          placeholder="Enter the text a canvasser will read..."
        />
      </Field.Root>
      <Field.Root>
        <Field.Label fontSize="sm">Script Text (Spanish)</Field.Label>
        <Textarea
          size="sm"
          rows={3}
          value={textContentSpanish}
          onChange={(e) => onChange('textContentSpanish', e.target.value)}
          placeholder="Texto en espanol..."
        />
      </Field.Root>
    </>
  );
}
